import React, { useCallback } from 'react';
import { Table, TableColumn } from '@jutro/layout';
import PropTypes from 'prop-types';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './ScheduleItemsDisplayComponent.metadata.json5';

function ScheduleItemsDisplayComponent(props) {
    const { value: ScheduleItemsData } = props;
    const getTableCell = useCallback((items, index, property) => {
        return items[property.header];
    },
    []);

    const getColumns = useCallback(() => {
        return Object.keys(ScheduleItemsData[0]).map(key => {
            return {
                columnHeader: key,
            };
        });
    }, [ScheduleItemsData]);


    const getTableColumns = useCallback(() => {
        const displayColumns = getColumns();
        let count = 0;
        const dynamicReactTable = displayColumns.map((displayColumn) => {
            const columnId = `col${count++}`;
            return (
                <TableColumn
                    id={columnId}
                    textAlign="left"
                    header={displayColumn.columnHeader}
                    cell={getTableCell}
                />
            );
        });
        return dynamicReactTable;
    }, [getColumns, getTableCell]);


    const renderTable = (scheduleItems) => {
        const noRecordsMessage = 'No records found';
        return (
            <>
                <div>
                    <Table data={scheduleItems} placeholder={noRecordsMessage}>
                        {getTableColumns()}
                    </Table>
                </div>
            </>
        );
    };

    const overrideProps = {
        ScheduleItemsContainer: {
            content: renderTable(ScheduleItemsData)
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={ScheduleItemsData}
            overrideProps={overrideProps}
        />
    );
}

ScheduleItemsDisplayComponent.propTypes = {
    value: PropTypes.shape({}).isRequired
};

export default ScheduleItemsDisplayComponent;
